import React, { useEffect, useState } from 'react';
import HouseKeepingList from './house-keeping/house-keeping-list/HouseKeepingList';
import './ServiceRequest.scss';
import { Button, Drawer, makeStyles } from '@material-ui/core';
import moment from 'moment';
import {
  HOUSE_KEEPING,
  CONCIERGE,
  HOUSEKEEPING_CREATE,
  HOUSEKEEPING_VIEW,
  CONCIERGE_CREATE,
  CONCIERGE_VIEW,
  HOUSEKEEPING_EDIT,
  CONCIERGE_EDIT,
} from '../../../constants/ServiceConstants';
import HouseKeepingCreate from './house-keeping/house-keeping-create/HouseKeepingCreate';
import HouseKeepingView from './house-keeping/house-keeping-view/HouseKeepingView';
import ConciergeList from './concierge/concierge-list/ConciergeList';
import ConciergeCreate from './concierge/concierge-create/ConciergeCreate';
import ConciergeView from './concierge/concierge-view/ConciergeView';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectedHotelSelector,
  allPropertyConfigsSelector,
  fetchAllPropertyConfigData,
} from '../../property/propertySlice';
import { useHistory } from 'react-router-dom';
import { validateUserSession } from '../../../utils/authUtils';
import SyncButton from '../../../shared/sync-button/Sync-Button';
import { syncHk } from '../../../utils/PropertyAPIUtils';
import { notificationManager } from '../../../utils/NotificationUtils';
import { generatedElapsedTime } from '../../../utils/dashboardUtils';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_SERVICE_REQUEST,
} from '../../../constants/RoleConsts';
import { fetchAllServiceReqeust } from '../servicesSlice';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const ServiceRequest = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(HOUSE_KEEPING);
  const [state, setState] = useState({ type: HOUSE_KEEPING, status: false });
  const [viewState, setViewState] = useState({
    type: HOUSEKEEPING_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [lastSync, setLastSync] = useState(0);
  const selectedHotel = useSelector(selectedHotelSelector);
  const propertyConfigs = useSelector(allPropertyConfigsSelector);

  const history = useHistory();

  useEffect(() => {
    if (selectedHotel) {
      dispatch(fetchAllPropertyConfigData(selectedHotel));
    }
  }, [selectedHotel]);

  useEffect(() => {
    if (propertyConfigs?.hk) {
      let timeDifference = generatedElapsedTime(
        moment(),
        moment.unix(propertyConfigs?.hk?.lastSyncedAt),
        true,
      );
      setLastSync(timeDifference);
    }
  }, [propertyConfigs]);

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  useEffect(() => {
    if (activeTab === HOUSE_KEEPING || activeTab === CONCIERGE) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(HOUSE_KEEPING);
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case HOUSEKEEPING_CREATE:
        return (
          <HouseKeepingCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></HouseKeepingCreate>
        );
      case HOUSEKEEPING_EDIT:
        return (
          <HouseKeepingCreate
            toggleDrawer={onDrawerToggle}
            obj={state.obj}
            hotelId={selectedHotel}
            editing={true}
            showLoader={showLoader}
          ></HouseKeepingCreate>
        );
      case CONCIERGE_CREATE:
        return (
          <ConciergeCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></ConciergeCreate>
        );
      case CONCIERGE_EDIT:
        return (
          <ConciergeCreate
            toggleDrawer={onDrawerToggle}
            obj={state.obj}
            hotelId={selectedHotel}
            editing={true}
            showLoader={showLoader}
          ></ConciergeCreate>
        );
      default:
        break;
    }
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case HOUSEKEEPING_VIEW:
        return (
          <HouseKeepingView
            onViewToggle={onViewToggle}
            onDrawerToggle={onDrawerToggle}
            object={viewState.obj}
            permissions={permissions}
          ></HouseKeepingView>
        );
      case CONCIERGE_VIEW:
        return (
          <ConciergeView
            onViewToggle={onViewToggle}
            onDrawerToggle={onDrawerToggle}
            permissions={permissions}
            object={viewState.obj}
          ></ConciergeView>
        );
      default:
        break;
    }
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const onClickSync = async (e) => {
    e.preventDefault();

    try {
      const res = await syncHk(selectedHotel);
      notificationManager(
        res?.data?.syncHK?.status ? 'success' : 'danger',
        res?.data?.syncHK?.message,
      );
      setTimeout(() => dispatch(fetchAllServiceReqeust(selectedHotel)), 2000);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>Service Request</span>
            </div>
            {propertyConfigs?.hk?.isEnabled &&
              permissions[RBAC_TYPE_SERVICES_SERVICE_REQUEST] ===
                RBAC_PERMISSION_LEVEL_FULL_ACCESS &&
              activeTab === HOUSE_KEEPING && (
                <div className='col-md-6 d-flex justify-content-end'>
                  <SyncButton lastSync={lastSync} onClickSync={onClickSync} />
                </div>
              )}
          </div>
          <div className='row d-flex mt-4 accommodation-list'>
            <div className='d-flex gap-3 flex-wrap'>
              <Button
                size='large'
                variant={activeTab === HOUSE_KEEPING ? 'outlined' : 'text'}
                className={
                  activeTab === HOUSE_KEEPING ? classes.activeButton : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(HOUSE_KEEPING)}
              >
                Housekeeping
              </Button>
              <Button
                size='large'
                variant={activeTab === CONCIERGE ? 'outlined' : 'text'}
                className={
                  activeTab === CONCIERGE ? classes.activeButton : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(CONCIERGE)}
              >
                Concierge
              </Button>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              {activeTab === HOUSE_KEEPING && (
                <HouseKeepingList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === CONCIERGE && (
                <ConciergeList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceRequest;
